import noImage from "../../assets/images/product/noimg.png"
export const DummyNoImg = noImage;
export const MAX_FILE_SIZE_MB = 5;
export const LOGIN = "/patient/login";
export const OTP_LOGIN = "/patient/otplogin";
export const VERIFY_OTP_LOGIN = "/patient/verifyotplogin";
export const GET_PRIMARY_MENU = "/primary_menu";
export const GET_HOME_PAGE_CATEGORY = "/homecollection?action_type=get-home-cate&home_type=1";
export const GET_HOME_PAGE_BANNER = "/homecollection?action_type=home-slider&slider_for=0&home_type=0";
export const GET_HOME_PAGE_TOP_BRAND = "/homecollection?action_type=get-brands&home_type=1";
export const GET_HOME_SHOP_HEALTH_CONDITION = "/homecollection?action_type=get-product-uses&home_type=1";
export const GET_SEARCHDATA = "/searchData";
export const GET_AI_SEARCHDATA = "/get-ai-search-reasult";
export const GET_POPULAR_PRODUCT = "/homepopular";
export const GET_STATE_AND_CITY_PINCODE = "/pincode/showCityAndState";
export const GET_ALL_CATEGORY = "/getcatall";
export const GET_ALL_BRAND = "/getBrandSeeAll";
export const GET_ALL_HEALTH_CONDITION = "/gethealthcondition";
export const GET_DETAILS = "/getDetail";
export const SIGN_UP = "/patient/signup";
export const VERIFY_OTP_SIGNUP = "/patient/verifyotp";
export const CART_DETAILS = "/cart_detail";
export const CART_INSERT = "/cart_insert";
export const CART_UPDATE = "/cart_update";
export const CART_DELETE = "/cart_delete";
export const GET_PATIENT_DETAILS = "/patient/getPateint";
export const UPDATE_USER = "/patient/updateuser";
export const FILTER_PRODUCTS = "/filterproducts";
export const GET_MEDICINE_DETAILS_LIST = "/getMedicineDetailList";
export const GET_HOME_SECTIONS = "/home_section";
export const GET_SORT_DATA = "/sorting";
export const GET_FAQ = "/faq";
export const GET_BLOG = "/blog";
export const GET_ADDRESS_LIST = "/patient/get_address_list";
export const ADD_ADDRESS = "/patient/address_create";
export const UPDATE_ADDRESS = "/patient/address_update";
export const DELETE_ADDRESS = "/patient/address_delete";
export const GET_PRESCRIPTION = "/patient/getPrescription";
export const UPLOAD_PRESCRIPTION = "/patient/uploadPrescription";
export const DELETE_PRESCRIPTION = "/delete-prescription";
export const GET_ORDER = "/getOrder";
export const GET_TRACK_ORDER = "/trackOrder";
export const GET_PAGES = "/pages";
export const STORE_VIEW_PRODUCT = "/store-viewed-product";
export const GET_RECENT_VIEW_PRODUCT = "/get-recent-viewed-product";
export const GET_PREVIOUS_ORDER = "/previous-order";
export const ITEM_RATING_DETAILS = "/itemrating/details";
export const ITEM_RATING_REVIEW_DETAILS = "/itemrating/review";
export const CREATE_RATING = "/itemrating/rating_create";
export const ADD_WISHLIST = "/add-product-to-wishlist";
export const GET_WISHLIST = "/get-product-wish-list";
export const MAKE_ADDRESS_DEFAULT = "/make-address-default";
export const ENQUIRTY_CREATE = "/enquirty/create";
export const GET_SUBSTITUTE_PRODUCT = "/get-substitute-product";
export const GET_COUPON = "/coupon";
export const USE_COUPON = "/singleUseCoupon";
export const MY_MEDICINE = "/myMedicine";
export const GET_CART_SUMMARY = "/get-cart-summary";
export const PAY_NOW = "/patient/paynow";
export const PURCHASE = "/patient/purchase";
export const RE_ORDER = "/re-order";
export const ENQUIRY_DELETE_PROFILE = "/enquirty/account_delete_profile";
export const CONTACT_US = "/enquirty/contact_us";
export const SUBSCRIBE = "/subscribe";
export const RESEND_OTP = "/patient/resend-otp";
export const VALIDATE_EMAIL_USER = "/patient/verify-email"
export const REGENERATE_EMAIL_LINK = "/patient/regenerate-email-verify-link"
